export const SANITIZE_MODES = [
  { id: 'plain', name: 'plain', description: 'plain' },
  { id: 'strict', name: 'strict', description: 'strict' },
  { id: 'none', name: 'none', description: 'none' }
];

export const normalizeSanitizeMode = (value) => {
  if (value && typeof value === 'object') {
    return String(value.name || value.description || value.id || '').trim().toLowerCase();
  }
  return String(value || '').trim().toLowerCase();
};

export const shouldApplyRegex = (element = {}) => {
  const mode = normalizeSanitizeMode(element.sanitize_mode);
  if (mode === 'plain' || mode === 'none') {
    return false;
  }
  if (mode === 'strict') {
    return !!element.validate_regex;
  }
  if (!element.validate_regex) {
    return false;
  }
  if (element.data_type === 'string' && element.type === 'field') {
    const maxLength = Number(element.max_length) || 0;
    return maxLength > 0 && maxLength < 200;
  }
  return element.data_type === 'number';
};
